(function ($) {
  window.onhashchange = scrollToHash;
  $(scrollToHash);

  function scrollToHash() {
    const anchor = $(location).attr("hash").replace("#", "");
    const anchorEl = document.getElementById(anchor);
    if (anchorEl) {
      const top = Math.max(anchorEl.offsetTop - $("header").outerHeight(), 0);
      window.scroll({
        behavior: "smooth",
        left: 0,
        top,
      });
    }
  }
})(jQuery);
